import { Icon } from '@iconify/react';
import cx from 'classnames';

export default function HeadingWithIcon({ icon, children, className }) {
  return (
    <div className={cx('flex gap-3', className)}>
      <Icon className="text-primary-500" height="36" icon={icon} />
      <h2 className="text-3xl">{children}</h2>
    </div>
  );
}
